import { createAction, props } from '@ngrx/store';

export const initState = createAction('[Luminaries] init');
export const loadLuminaries = createAction('[Luminaries] load');
export const update = createAction('[Luminaries] update', props<{id, changes: any}>());
export const create = createAction('[Luminaries] create', props<{luminary: any}>());
export const remove = createAction('[Luminaries] delete', props<{_id: Number}>());

